import React, { useState } from "react";
import "./MessagesContainer.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updateMessages } from "Redux/Actions/messagesActions";
import MessageCard from "./MessageCard/MessageCard";
import { HiSearch } from "react-icons/hi";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import neutralUser from "assets/neutralUser.png";

const MessagesContainer = (props) => {
  const [filtreMotsCles, setFiltreMotsCles] = useState("");
  const [newMessage, setNewMessage] = useState("");

  // Nom de la personne avec qui l'on discute
  let membersConversation = "";
  props.messages.currentConversation.users.forEach((user) => {
    if (user.id !== props.auth.userConnected.id)
      membersConversation = user.firstname + " " + user.surname;
  });

  // Filtre le messages par rapport à leurs contenu
  const filterByMotsCles = (listMessages) => {
    if (filtreMotsCles && filtreMotsCles != "") {
      return listMessages.filter((message) =>
        message.content.toLowerCase().includes(filtreMotsCles.toLowerCase())
      );
    }
    return listMessages;
  };

  // Envoie un nouveau message
  const sendMessage = () => {
    // Formate de body
    const data = {
      content: newMessage,
      conversation: `api/conversations/${props.messages.currentConversation.id}`,
      user: `api/users/${props.auth.userConnected.id}`,
      messageStatus: `api/message_statuses/${props.messages.newId}`,
    };
    axios
      .post(`${process.env.REACT_APP_BASE_URL_API}/messages`, data, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((res) => {
        // Formate la réponse
        const formatedResponse = {
          id: res.data.id,
          createdAt: res.data.createdAt,
          content: res.data.content,
          user: props.messages.currentConversation.users.filter(
            (user) => user.id === props.auth.userConnected.id
          )[0],
          messageStatus: `api/message_statuses/${props.messages.newId}`,
        };
        // AJoute le nouveau message à la current conv
        let tempCurrentConv = props.messages.currentConversation;
        tempCurrentConv.messages.unshift(formatedResponse);
        // Ajoute la current conv aux convs
        const tempConv = props.messages.myConversations.map((conv) => {
          if (conv.id === tempCurrentConv.id) return tempCurrentConv;
          else return conv;
        });
        // Réordonne les convs
        props.orderConversations(tempConv);
        setNewMessage("");
      })
      .catch((error) => {
        props.cancelToast.current.show({
          severity: "error",
          summary: "error : ",
          detail: `Une erreur est survenue, le message n'a pas pu être envoyé. ${error.message}`,
          life: 3000,
        });
      })
      .finally(() => {
        showConversation();
      });
  };

  const showConversation = () => {
    const data = {};
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}/conversations/show/${props.messages.currentConversation.id}`,
        data,
        {
          accept: "application/json",
          Authorization: `Bearer ${props.auth.token}`,
        }
      )
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  // Change le status des messages à l'ouverture de la conv NEW => OPEN
  const openMessage = (message) => {
    const data = {
      messageStatus: `api/message_statuses/${props.messages.openId}`,
    };
    axios
      .put(
        `${process.env.REACT_APP_BASE_URL_API}/messages/${message.id}`,
        data,
        {
          accept: "application/json",
          Authorization: `Bearer ${props.auth.token}`,
        }
      )
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };
  return (
    <div className="messages_container">
      <div className="messages_container_top">
        <span>{membersConversation}</span>
        <div className="search_message">
          <HiSearch className="search_message_icon" />
          <InputText
            placeholder={`Rechercher un message`}
            value={filtreMotsCles}
            onChange={(e) => {
              setFiltreMotsCles(e.target.value);
            }}
            className="search_message_input"
          />
        </div>
      </div>

      <div className="messages_container_bottom">
        {props.messages.currentConversation &&
        filterByMotsCles(props.messages.currentConversation?.messages).length >
          0 ? (
          filterByMotsCles(props.messages.currentConversation?.messages)
            .sort((a, b) => {
              return new Date(a.createdAt) - new Date(b.createdAt);
            })
            .map((message, index) => (
              <MessageCard key={index} messageDetails={message}></MessageCard>
            ))
        ) : props.messages.currentConversation?.messages.length > 0 ? (
          <span className="empty_message">
            Aucun message ne correspond à votre recherche
          </span>
        ) : (
          <span className="empty_message">
            Vous n&apos;avez échangé aucun message
          </span>
        )}
      </div>
      <div className="messages_container_input">
        <img
          src={
            props.auth.userConnected.imageUrl
              ? props.auth.userConnected.imageUrl
              : neutralUser
          }
        ></img>
        <div className="messages_container_input_textarea">
          <InputText
            placeholder={`Écrire...`}
            value={newMessage}
            onChange={(e) => {
              setNewMessage(e.target.value);
            }}
            onKeyDown={(e) => {
              e.key === "Enter" && sendMessage();
            }}
            onClick={() => {
              props.messages.currentConversation.messages
                .filter(
                  (message) =>
                    message.user.id !== props.auth.userConnected.id &&
                    message.messageStatus.split("/")[3] == 1
                )
                .forEach((message) => openMessage(message));

              props.messages.currentConversation.messages.forEach(
                (message) =>
                  (message.messageStatus = `api/message_statuses/${props.messages.openId}`)
              );
              props.handleMessages({
                myConversations: props.messages.myConversations.map(
                  (conversation) => {
                    if (conversation.id === props.messages.currentConversation)
                      return props.messages.currentConversation;
                    else return conversation;
                  }
                ),
                currentConversation: props.messages.currentConversation,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

MessagesContainer.propTypes = {
  auth: PropTypes.object,
  messages: PropTypes.object,
  handleMessages: PropTypes.func,
  orderConversations: PropTypes.func,
  cancelToast: PropTypes.func,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  messages: state.messages,
});

const mapDispatchToProps = (dispatch) => ({
  handleMessages: (value) => {
    dispatch(updateMessages(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MessagesContainer);
